import React, { Component } from "react";
import PropTypes from "prop-types";

class SelfDiagnosticLogo extends Component {
  static propTypes = {
    colour: PropTypes.string
  };

  render() {
    const { colour } = this.props;
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="160"
        height="140"
        viewBox="0 0 160 140"
      >
        <path
          fill={colour || "#000"}
          fillRule="evenodd"
          d="M159.26 131.607L85.03 2.871C84.01 1.097 82.09 0 80 0c-2.09 0-4.01 1.097-5.03 2.871L.75 131.607a5.491 5.491 0 0 0 .04 5.604A5.804 5.804 0 0 0 5.77 140h148.46c2.05 0 3.94-1.062 4.98-2.789a5.514 5.514 0 0 0 .05-5.604zm-88.43-8.078h18.34v-16.47H70.83v16.47zm0-28.826h18.34V45.291H70.83v49.412z"
        />
      </svg>
    );
  }
}

export default SelfDiagnosticLogo;



// WEBPACK FOOTER //
// ./src/modules/general-info/self-diagnosis-logo.js